import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { MdToHtmlPipe } from '../_pipes/md-to-html.pipe';
import { SafeStringPipe } from '../_pipes/safe-string.pipe';
import { RichTextPipe } from '../_pipes/rich-text.pipe';
import { ArticlesComponent } from './articles/articles.component';


@NgModule({
  declarations: [
    FooterComponent,
    HeaderComponent,
    ArticlesComponent,

  ],
  imports: [
    CommonModule,
    SafeStringPipe,
    MdToHtmlPipe,
    RichTextPipe
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    ArticlesComponent
  ]
})
export class LayoutMangmentModule { }
